import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';


const Item = (props) => {
  return (
    !props.hide &&
      <Menu.Item
        name={props.name}
        as={NavLink}
        to={props.to}
      />
  );
};

export default Item;



// WEBPACK FOOTER //
// ./src/common/components/Header/Item.js